<div class="login-content mat-typography">
    <mat-card appearance="outlined" class="app-input-section">
      <mat-card-content>
        <div fxLayout="column">
          <h1 class="mat-h1" i18n="@@login">Login</h1>
          <mat-form-field>
            <mat-label i18n="@@username">Username</mat-label>
            <input matInput (keydown.enter)="login()" [(ngModel)]="model.email" #username="ngModel" required/>
          </mat-form-field>
  
          <mat-form-field>
            <mat-label i18n="@@password">Password</mat-label>
            <input matInput (keydown.enter)="login()" [(ngModel)]="model.password" #password="ngModel" required type="password" />
          </mat-form-field>
  
          <p *ngIf="error" class="error">{{error}}</p>
  
          <button mat-raised-button color="primary" class="app-sidebar-button" (click)="login()" [disabled]="loading" i18n="@@login">
            <mat-icon class="example-icon">verified_user</mat-icon>
            <mat-spinner class="button-load-element" *ngIf="loading" diameter="24"></mat-spinner>
            Login
          </button>
  
        </div>
      </mat-card-content>
    </mat-card>
  
  </div>